module.exports = __webpack_public_path__ + "59da5f61770ba84de72bced48061a6c7.svg";